/**
 * 前端 agent 常量（与后端 AgentConstants 对齐）。
 */

export const AgentConstants = {
  DEFAULT_COMMAND_TIMEOUT_MS: 8000,
  ROUTE_COMMAND_TIMEOUT_MS: 30000,
  GRID_COMMAND_TIMEOUT_MS: 30000,
  /**
   * 路线/tour 分析是重管线（服务区→空间查询→最近设施→TSP→多权重 findPath），
   * 一次确认轻松超过 30 秒。后端对 route 命令下发 timeoutMs=30000 远不够——超时会让
   * agent 误判失败并重试，后台分析继续堆积、loading 卡死。前端对这类命令放宽到 3 分钟。
   */
  ROUTE_COMMAND_SOFT_TIMEOUT_MS: 180000,

  FAIL_CONTINUE: "continue",
  FAIL_RETRY: "retry",
  FAIL_BLOCK: "block",
  FAIL_DEGRADE: "degrade",

  CMD_SUCCESS: "success",
  CMD_FAILED: "failed",
  CMD_TIMEOUT: "timeout",
  CMD_CANCELLED: "cancelled",
  CMD_SKIPPED: "skipped",

  PLAN_PENDING: "pending_commands",
  PLAN_COMPLETED: "completed",
  PLAN_DEGRADED: "degraded",
  PLAN_FAILED: "failed",
  PLAN_UNKNOWN: "unknown"
} as const;
